import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import inicio from '@/pages/inicio'
import adaptaclima from '@/pages/adaptaclima'
import conoceRiesgos from '@/pages/conoceRiesgos'

export default new Router({
  routes: [
      {
        path:'/',
        component: inicio,
        name:'inicio'
      },
      {
        path:'/adaptaclima',
        component: adaptaclima,
        name:'adaptaclima'
      },
      {
        path:'/conoceRiesgos',
        component: conoceRiesgos,
        name:'conoceRiesgos'
      },
    ],
    scrollBehavior() {
      document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
    }
  })
